<template>
  <div class="wrapper">
    <div class="info head">
      <span class="label">Profile：</span>
      <div class="r">
        <div class="user-head">
          <input
            type="file"
            class="input-file"
            name="avatar"
            ref="avatarInput"
            @change="changeImage($event)"
            accept="image/gif, image/jpeg, image/jpg, image/png"
          >
          <img :src="userImage" alt v-loading="loadingShow">
          <div class="change">{{$t('change')}}{{$t('avatar')}}</div>
        </div>
      </div>
    </div>

    <el-form ref="form" :model="form" :rules="rules" label-width="130px" label-position="left" >
      <el-form-item label="Name" prop="userName">
        <el-input type="text" class="input" v-model="form.userName"></el-input>
      </el-form-item>

      <el-form-item :label="$t('sex')" prop="sex">
        <el-radio v-model="form.sex" :label="1">{{$t('man')}}</el-radio>
        <el-radio v-model="form.sex" :label="2">{{$t('woman')}}</el-radio>
      </el-form-item>

      <el-form-item label="Email" prop="email">
        <el-input type="text"  class="input" v-model="form.email"></el-input>
      </el-form-item>

      <el-form-item label="Country：" prop="country">
            <el-input type="text" @focus="visible = true" class="input" :value="area_name || userInfo.area_name ||  'Choose'"></el-input>
      </el-form-item>

      <el-form-item label="Mobile" prop="mobile">
        <el-input type="text"  class="input" v-model="form.mobile"></el-input>
      </el-form-item>

      <el-form-item label="Address：" prop="address">
        <el-input type="text"  class="input" v-model="form.address"></el-input>
      </el-form-item>


       <el-form-item label="Postal Code" prop="postalcode">
        <el-input type="text"  class="input" v-model="form.postalcode"></el-input>
      </el-form-item>
    </el-form>

    <div class="save" @click="saveInfo">{{$t('save')}}</div>

    <el-dialog title="Country" :visible="visible" :show-close="false">
      <div>
        <div class="info dialog">
          <span class="label">Country：</span>
          <div class="r">
            <div class="form-section form-adress form-location">
              <span class="must">*</span>
              <el-cascader  size="medium" :options="options" separator=" " 
              placeholder="Country" v-model="selectedOptions"></el-cascader>
            </div>
          </div>
        </div>

        <div class="form-foot">
          <div class="foot-btn save" @click="save">{{$t('save')}}</div>
          <div class="foot-btn cancel" @click="visible = false">{{$t('cancel')}}</div>
        </div>
      </div>
        
    </el-dialog>
  </div>
</template>

<script>
import { apiBaseUrl } from "@/config/env.js";
export default {
  name: "UserInfo",
  components: {},
  props: {},
  data() {
    return {
      userInfo: {},
      userImage: "",
      userName: "",
      sex: 1,
      birthday: "",
      upLoadUrl: apiBaseUrl + "api.html",
      loadingShow: false,
      email: '',
      address: '',
      mobile: '',
      postalcode: '',
      selectedOptions: [],
      options: [], //省市联动数据
      area_id: '',
      areaKey: '',
      cityKey: '',
      provinceKey: '',
      change: false,
      visible: false,
      area_name: '',
      form: {
        userName: '',
        sex: '1',
        email: '',
        country: '',
        mobile: '',
        address: '',
        postalcode: ''
      },
      rules: {
        userName: [
          { required: true, message: this.$t('mobileorAccountNo'), trigger: 'blur' },
        ],
        sex: [
          { required: true, message: 'choose', trigger: 'change' },
        ],
        email: [
          { required: true, message: this.$t('mobileorAccountNo'), trigger: 'blur' },
        ],
        country: [
          { required: true, message: this.$t('mobileorAccountNo'), trigger: 'change' },
        ],
        mobile: [
          { required: true, message: this.$t('mobileorAccountNo'), trigger: 'blur' },
        ],
        address: [
          { required: true, message: this.$t('mobileorAccountNo'), trigger: 'blur' },
        ],
        postalcode: [
          { required: true, message: this.$t('mobileorAccountNo'), trigger: 'blur' },
        ],
      }
    };
  },
  watch: {
    selectedOptions(newVal, oldval) {
      this.form.country = this.selectedOptions[this.selectedOptions.length - 1]
      // this.selectedOptions = this.pickerIndexArr;
    }
  },
  methods: {
    save() {
      let _this = this
      this.visible = false
      this.$api.getareaname({
        area_id: this.selectedOptions[this.selectedOptions.length - 1]
      }).then(res => {
        if(res.status) {
          _this.$set(_this.$data, 'area_name', res.data.area_name)
        }
      })
    },
    getTreeData(data){
      for(let i=0;i<data.length;i++){
        if('children' in data[i]) {
          if(!data[i].children || data[i].children.length<1){
            data[i].children=undefined;
          }else {
            this.getTreeData(data[i].children);
          }
        }
      }
      return data;
    },
    saveInfo(val) {

       this.$refs.form.validate((valid) => {
         if(valid) {
           let {country, postalcode,  ...formdata} = this.form
            let data = {
              ...formdata,
              nickname: this.form.userName,
              area_id : this.selectedOptions[this.selectedOptions.length - 1] || this.area_id,
              zipcode: this.form.postalcode
              // sex: this.sex,
              // email: this.email,
              // address: this.address,
              // mobile: this.mobile,
              // zipcode: this.postalcode,
            };
            this.$api.editInfo(data).then(res => {
              if (res.status) {
                this.$message({
                  message:  'Sign-In successfully! Please visit HOME page to continue your shopping list. ' ,
                  type: 'success',
                  offset: 400,
                  duration: 5000,
                  showClose: true
                })
                // this.$msg();
                this.getUserInfo();
              } else {
                this.$msg(res.msg, "error");
              }
            });
         }
       })
    },
    changeImage(e) {
      this.loadingShow = true;
      let file = e.target.files[0];
      var formdata = new FormData();
      formdata.append("upfile", file, file.name);
      this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
        if (res.status) {
          let data = {
            avatar: res.data.url
          };
          this.$api.changeAvatar(data).then(r => {
            if (r.status) {
              this.$msg(r.msg);
              this.userImage = r.data.avatar;
            } else {
              this.$msg(r.msg, "error");
            }
          });
        } else {
          this.$msg(res.msg, "error");
        }
        this.loadingShow = false;
      });
    },
    getUserInfo() {
      this.$api.userInfo().then(result => {
        if (result.status) {
          this.userInfo = result.data;
          this.userImage = this.userInfo.avatar;
          if(this.userInfo.nickname == '****') {
            this.form.userName = '';
          } else {
            this.form.userName = this.userInfo.nickname;
          }
          this.form.email = this.userInfo.email;
          this.form.address = this.userInfo.address;
          this.form.mobile = this.userInfo.mobile;
          this.form.postalcode = this.userInfo.zipcode;
          this.form.country = this.userInfo.area_id
          this.form.sex = this.userInfo.sex == 3 ? 1 : this.userInfo.sex;
          this.selectedOptions.push(this.userInfo.area_id)

          if(!this.userInfo.area_id) {
            this.$message({
              message: 'Please fill in details to proceed your purchase with Sanlida Archery! ',
              duration: 10000,
              offset: 200
            })
          }
        }
      });
    }
  },
  mounted() {
    let addressList = this.$storage.get('areaList')
    this.options = this.getTreeData(addressList)
    this.getUserInfo();

    
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.input {
  width: 200px;
}
.dialog{
  padding: 30px;
}
.wrapper {
  .save {
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: $theme-color;
    color: #fff;
    margin-left: 130px;
    margin-top: 30px;
    cursor: pointer;
  }
  .info {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    &.head {
      align-items: flex-start;
      .label {
        padding-top: 10px;
      }
    }
    .label {
      display: inline-block;
      width: 110px;
      margin-right: 20px;
    }
    .r {
      .user-head {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: relative;
        &:hover {
          .change {
            display: block;
          }
        }
        .input-file {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
          z-index: 99;
        }
        .change {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 70px;
          height: 18px;
          margin-left: -35px;
          line-height: 18px;
          text-align: center;
          margin-top: -8px;
          background: #757575;
          color: #fff;
          cursor: pointer;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .info-input {
        width: 160px;
        height: 24px;
        line-height: 24px;
        border: 1px solid $border;
        padding-left: 12px;
      }
    }
  }
}

.form-section {
    position: relative;
    margin-bottom: 15px;
    .must {
      position: absolute;
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      color: #e7442f;
    }
}
.form-foot {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  .foot-btn {
    width: 160px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
    &.save {
      background: $theme-color;
      margin-right: 20px;
      margin-top: 0;
      margin-left: -90px;
    }
    &.cancel {
      background: #b0b0b0;
      transition: all 0.2s;
      &:hover {
        background: #757575;
      }
    }
  }
}
</style>